import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Placeholder from "@/components/Placeholder";
import { Phone, PlayCircle, CalendarCheck, ArrowRight, MapPin } from "lucide-react";

const MAP_STEPS = [
  { t: "Friday Night", to: "/portal/training", label: "Watch Module 1" },
  { t: "Saturday AM", to: "/portal/assets", label: "Open Asset Vault" },
  { t: "Saturday PM", to: "/portal/demo-offer", label: "Build Demo Offer" },
  { t: "Sunday AM", to: "/portal/scripts", label: "Load Scripts" },
  { t: "Sunday Night", to: "/portal/weekend-plan", label: "You're open" },
];

export default function StartHere() {
  const { user } = useAuth();
  return (
    <div data-testid="start-here-page">
      <div className="eyebrow" style={{ color: "#2038E6" }}>Start Here</div>
      <h1 className="h-display" style={{ fontSize: "clamp(32px,5vw,52px)", marginTop: 8 }}>
        You're In. Launch Is This Weekend.
      </h1>
      <p style={{ color: "var(--muted)", marginTop: 12, fontSize: 18 }}>
        Welcome{user?.email ? `, ${user.email}` : ""}. Here is exactly what to do next.
      </p>

      {/* 3-step orientation */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 16, marginTop: 28 }}>
        {[
          { n: 1, icon: PlayCircle, title: "Watch Module 1 tonight", to: "/portal/training", cta: "Open the training" },
          { n: 2, icon: CalendarCheck, title: "Block your Friday to Sunday", to: "/portal/weekend-plan", cta: "See the plan" },
          { n: 3, icon: Phone, title: "Book your 1-on-1 Launch Call now while spots exist", to: "/portal/book-call", cta: "Book the call" },
        ].map(({ n, icon: Icon, title, to, cta }) => (
          <div key={n} className="card-paper" style={{ padding: 22, display: "flex", flexDirection: "column" }}>
            <div className="font-mono-plex" style={{ color: "#2038E6", fontSize: 13 }}>STEP {n}</div>
            <Icon size={26} color="#0F1317" style={{ marginTop: 10 }} />
            <h3 className="font-archivo" style={{ fontWeight: 800, fontSize: 18, marginTop: 12, flex: 1 }}>{title}</h3>
            <Link to={to} className="font-archivo" style={{ marginTop: 14, color: "#2038E6", fontWeight: 700, textTransform: "uppercase", fontSize: 13, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
              {cta} <ArrowRight size={15} />
            </Link>
          </div>
        ))}
      </div>

      {/* Prominent launch call card */}
      <Link to="/portal/book-call" data-testid="launch-call-card" style={{ textDecoration: "none", display: "block", marginTop: 28 }}>
        <div style={{ background: "#0F1317", color: "#E9ECE7", borderRadius: 16, padding: 28, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 20, flexWrap: "wrap" }}>
          <div>
            <div className="font-mono-plex" style={{ color: "#FFDF57", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.1em" }}>Limited spots each month</div>
            <div className="font-archivo" style={{ fontWeight: 900, fontSize: 26, color: "#fff", marginTop: 6 }}>Book your 1-on-1 Launch Call</div>
          </div>
          <span className="btn-cobalt"><Phone size={18} /> Book now</span>
        </div>
      </Link>

      {/* Weekend Map */}
      <div style={{ marginTop: 40 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <MapPin size={18} color="#2038E6" />
          <h2 className="font-archivo" style={{ fontWeight: 900, textTransform: "uppercase", fontSize: 22 }}>The Weekend Map</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 12, marginTop: 16 }}>
          {MAP_STEPS.map((s, i) => (
            <Link key={i} to={s.to} data-testid={`weekend-map-step-${i + 1}`} className="card-paper" style={{ padding: 18, textDecoration: "none", color: "#0F1317", display: "block" }}>
              <div className="font-mono-plex" style={{ fontSize: 26, fontWeight: 600, color: "#2038E6" }}>{i + 1}</div>
              <div className="font-archivo" style={{ fontWeight: 800, marginTop: 6, fontSize: 15 }}>{s.t}</div>
              <div style={{ color: "var(--muted)", fontSize: 13, marginTop: 4 }}>{s.label}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
